import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "review-countries-status dialog-modal-container" }
const _hoisted_2 = { class: "review-countries-status-logo" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "review-countries-status-header" }
const _hoisted_5 = { class: "review-countries-status-body" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "review-countries-status-body-header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Country"),
  /*#__PURE__*/_createElementVNode("div", null, "Action")
], -1)
const _hoisted_7 = { class: "review-countries-status-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    open: _ctx.isOpen,
    width: 395,
    onCloseDialog: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeDialog')))
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "flex mx-auto mb-8",
            src: require('@/assets/refreshedHumanFlag.svg'),
            alt: "Yellowcard Logo"
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('reviewStatusChange.headingText')), 1),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingChanges, (rate) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "review-countries-status-body-row",
              key: rate.id
            }, [
              _createElementVNode("div", null, _toDisplayString(_ctx.mapCountryCode(rate.locale)) + " ( " + _toDisplayString(rate.code) + " )", 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.titleCase(rate.action)), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Button, {
            onClick: _ctx.denyRequest,
            variant: "outline",
            text: "Deny",
            size: "large",
            radius: 10,
            disabled: _ctx.denyButtonDisabled
          }, null, 8, ["onClick", "disabled"]),
          _createVNode(_component_Button, {
            onClick: _ctx.approveRequest,
            text: "Approve",
            size: "large",
            radius: 10,
            disabled: _ctx.approveButtonDisabled
          }, null, 8, ["onClick", "disabled"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}